const FORM_CONTROL_SIZES = {
  SMALL: 'sm',
  LARGE: 'lg',
};

const FORM_TEXT_TYPES = {
  DEFAULT: 'default',
  VALID: 'valid',
  INVALID: 'invalid',
  WARNING: 'warning',
  CRITERIA_EMPTY: 'criteria-empty',
  CRITERIA_VALID: 'criteria-valid',
  CRITERIA_INVALID: 'criteria-invalid',
};

export { FORM_CONTROL_SIZES, FORM_TEXT_TYPES };
